import Router from 'vue-router'
import Vue from 'vue'

import HelloWorld from '@/components/HelloWorld'
import home from '@/views/homePage'
import transferPage from '@/views/transferPage'
import transmitPage from '@/views/transmitPage'
import commonProblem from '@/views/commonProblem'
import sendFeedback from '@/views/sendFeedback'
import aboutPage from '@/views/aboutPage'
import changePassword from '@/views/changePassword'
import modifiedData from '@/views/modifiedData'
import homePage from '@/components/homePage'

Vue.use(Router)

const isElectron =
  typeof window !== 'undefined' &&
  window.process &&
  window.process.versions &&
  window.process.versions.electron

const router = new Router({
  mode: isElectron ? 'abstract' : 'hash',
  routes: [
    {
      path: '/',
      name: 'homePage',
      component: homePage
    },
    {
      path: '/login',
      name: 'login',
      component: HelloWorld
    },
    {
      path: '/HelloWorld',
      redirect: '/login'
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/transferPage',
      name: 'transferPage',
      component: transferPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/transmitPage',
      name: 'transmitPage',
      component: transmitPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/commonProblem',
      name: 'commonProblem',
      component: commonProblem,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sendFeedback',
      name: 'sendFeedback',
      component: sendFeedback,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/aboutPage',
      name: 'aboutPage',
      component: aboutPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/changePassword',
      name: 'changePassword',
      component: changePassword,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/modifiedData',
      name: 'modifiedData',
      component: modifiedData,
      meta: {
        requiresAuth: true
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token')
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  next()
})

export default router
